import { defineMessages } from 'react-intl';

export default defineMessages({
  annualFixedRevenue: {
    id:
      'legal_proceedings.expert_report.accounting_expertise.fixed_annual_revenue',
  },
  medicalPharmaceuticalFees: {
    id:
      'legal_proceedings.expert_report.medical_expertise.medical_pharmaceutical_fees',
  },
  ipp: {
    id: 'legal_proceedings.expert_report.medical_expertise.ipp',
  },
  itt: {
    id: 'legal_proceedings.expert_report.medical_expertise.itt',
  },
  thirdPartyAppeal: {
    id: 'legal_proceedings.expert_report.medical_expertise.third_party_appeal',
  },
  pretiumDoloris: {
    id: 'legal_proceedings.expert_report.medical_expertise.pretium_doloris',
  },
  aestheticDamageWithoutConsequence: {
    id:
      'legal_proceedings.expert_report.medical_expertise.aesthetic_damage_without_consequence',
  },
  aestheticDamageWithConsequence: {
    id:
      'legal_proceedings.expert_report.medical_expertise.aesthetic_damage_with_consequence',
  },
  careerPrejudice: {
    id: 'legal_proceedings.expert_report.medical_expertise.career_prejudice',
  },
  schoolingPrejudice: {
    id: 'legal_proceedings.expert_report.medical_expertise.schoolingPrejudice',
  },
  expertReportpourcentage: {
    id: 'legal_proceedings.expert_report.percentage',
  },
  medicalvictimRevenu: {
    id: 'legal_proceedings.expert_report.medical_expertise.victim_revenu',
  },
  causalityLink: {
    id:
      'legal_proceedings.expert_report.medical_expertise.victim_causality_link',
  },
  isDeathRelatedToClaim: {
    id:
      'legal_proceedings.expert_report.medical_expertise.victim_is_death_related_to_claim',
  },
  damageAmount: {
    id: 'legal_proceedings.expert_report.mechanical_expertise.damage_amount',
  },
  newDocument: {
    id: 'legal_proceedings.expert_report.mechanical_expertise.new_document',
  },
  creatorTitle: {
    id: 'court_manager_legal_proceedings_page.expert_report.creator.title',
  },
  deprecated: {
    id: 'court_manager_legal_proceedings_page.expert_report.deprecated',
  },
});
